import React from 'react';

import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import TasksTable from '../components/TasksTable';
import { TaskInterface } from '@hydra/routes/marketing-checklist/components/TaskItem';

const useStyles = makeStyles(theme => ({
  root: {
    margin: `${theme.spacing(4)}px auto`
  }
}));

interface MarketingChecklistPageProps {
  tasks: TaskInterface[],
  url: string
}

export default function MarketingChecklistPage ({ tasks, url }: MarketingChecklistPageProps) {
  const classes = useStyles();
  return (
    <Container
      maxWidth='lg'
      className={classes.root}
    >
      <Typography variant='h3' gutterBottom>
        <Translate content='todo_headtitle' />
      </Typography>
      <Typography paragraph>
        <Translate content='tips_header' with={{ domain: url }} />
      </Typography>
      <br />
      <TasksTable tasks={tasks} url={url} />
    </Container>
  );
}
